var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, delay, put, race, take } from 'redux-saga/effects';
import { delayAfterPollingInMS, delayBeforeStartPollingInMS } from '~store';
import { request } from '~utils/request';
import { startPolling, stopPolling, successPolling } from './index';
// @ts-expect-error
function pollTask(payload) {
    var data, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 8, , 10]);
                return [4 /*yield*/, delay(delayBeforeStartPollingInMS)];
            case 1:
                _a.sent();
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'bp/v1/bp-integrator/providers/balances/poll',
                        params: {
                            'request-id': payload,
                        },
                    })];
            case 2:
                data = (_a.sent()).data;
                if (!!data.requestId) return [3 /*break*/, 5];
                // TODO fix polling after BE will fix the issue
                return [4 /*yield*/, put(successPolling(data.responseObject))];
            case 3:
                // TODO fix polling after BE will fix the issue
                _a.sent();
                return [4 /*yield*/, put(stopPolling())];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [4 /*yield*/, delay(delayAfterPollingInMS)];
            case 6:
                _a.sent();
                // @ts-expect-error
                return [4 /*yield*/, call(pollTask, data.requestId)];
            case 7:
                // @ts-expect-error
                _a.sent();
                return [3 /*break*/, 10];
            case 8:
                err_1 = _a.sent();
                console.error(err_1);
                return [4 /*yield*/, put(stopPolling())];
            case 9:
                _a.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function pollTaskWatcher() {
    var payload, timeout;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, take(startPolling.toString())];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, race({
                        task: call(pollTask, payload),
                        cancel: take(stopPolling.toString()),
                        timeout: delay(60000),
                    })];
            case 2:
                timeout = (_a.sent()).timeout;
                if (!timeout) return [3 /*break*/, 4];
                return [4 /*yield*/, put(stopPolling())];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
}
